import { render, staticRenderFns } from "./campaignOverview.vue?vue&type=template&id=581fad80&"
import script from "./campaignOverview.vue?vue&type=script&lang=js&"
export * from "./campaignOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports